<template>
  <div>
    <p>
      We manufacture architectural load-bearing columns in a full range of sizes, surface textures and color treatments.
      We also offer columns with highly uniform as-cast surfaces for application of decorative stone veneer.
    </p>
    <carousel item="columns" :images="images"></carousel>
  </div>
</template>

<script>
  import Carousel from '@/components/Carousel'

  export default {
    name: "Columns",
    components: {Carousel},
    data() {
      return {
        images: [
          'columns-0.jpeg',
          'columns-1.jpeg',
          'columns-2.jpeg',
          'columns-3.jpeg',
        ]
      }
    }
  }
</script>

<style scoped>

</style>